import React, { useState } from 'react';
export function FAQSection() {
  const faqs = [{
    q: 'Come scarico il materiale?',
    a: "Riceverai un link via email immediatamente dopo l'acquisto. Un clic e tutto il MegaPack sarà sul tuo computer. 100% PDF, senza app o piattaforme extra."
  }, {
    q: 'Posso stamparlo o proiettarlo?',
    a: 'Sì! Essendo in PDF puoi stamparlo per i tuoi studenti, caricarlo sulla LIM o inviare schede specifiche via Classroom.'
  }, {
    q: 'È adatto a Licei o Tecnici?',
    a: 'È strutturato per coprire le basi comuni del primo biennio e gli approfondimenti del triennio, rendendolo versatile per ogni tipo di scuola secondaria.'
  }, {
    q: 'I 6 bonus sono inclusi in tutte le offerte?',
    a: 'Sì. I 6 bonus sono inclusi sia in Fisica Pronta che nel Combo Scienze senza costi extra.'
  }, {
    q: 'Posso acquistare solo Fisica ora e Chimica dopo?',
    a: "Sì. Puoi iniziare con Fisica, ma il Combo Scienze ti fa risparmiare notevolmente rispetto all'acquisto separato."
  }];
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section aria-label="Domande frequenti" className="bg-brand-dark py-32 px-4 border-t border-brand-border" data-id="element-73">
      <div className="max-w-4xl mx-auto" data-id="element-74">
        <h2 className="text-4xl md:text-5xl font-heading font-bold text-center text-white mb-16" data-id="element-75">
          ❓ DOMANDE <span className="text-brand-accent" data-id="element-76">FREQUENTI</span>
        </h2>
        <div className="space-y-4" data-id="element-77">
          {faqs.map((faq, i) => <div key={i} className="bg-brand-card rounded-2xl border border-brand-border overflow-hidden" data-id="element-78">
              <button className="w-full px-8 py-6 text-left flex justify-between items-center focus:outline-none focus-visible:ring-2 focus-visible:ring-brand-accent hover:bg-white/5 transition-colors" onClick={() => setOpenIndex(openIndex === i ? null : i)} aria-expanded={openIndex === i} data-id="element-79">
                <span className="font-bold text-white text-lg pr-8" data-id="element-80">
                  <span className="text-brand-accent mr-2" data-id="element-81">{i + 1} —</span>{' '}
                  {faq.q}
                </span>
                <span className={`text-brand-accent text-2xl flex-shrink-0 transition-transform duration-300 leading-none ${openIndex === i ? 'rotate-180' : ''}`} aria-hidden="true" data-id="element-82">
                  ▾
                </span>
              </button>
              {openIndex === i && <div role="region" data-id="element-83">
                  <div className="px-8 pb-8 text-white/80 border-t border-brand-border pt-6 text-lg leading-relaxed" data-id="element-84">
                    {faq.a}
                  </div>
                </div>}
            </div>)}
        </div>
      </div>
    </section>;
}